import authApi from '@/services/api/authApi';
import {
  getToken, saveToken, destroyToken, getRefreshToken,
} from '@/services/jwt.service';
import accountApi from '@/services/api/accountApi';

const initialState = () => ({
  initialized: false,
  loading: false,
  user: { id: 123 }, // null
  accessToken: getToken(),
  refreshToken: getRefreshToken(),
});

export default {
  namespaced: true,
  state: initialState,
  actions: {
    async login({ commit }, { login, password }) {
      commit('setLoading', true);
      try {
        const response = await authApi.login({ login, password });
        const { access_token: accessToken, refresh_token: refreshToken } = response.data;
        commit('setToken', { accessToken, refreshToken });
        // await dispatch('loadMe');
        return true;
      } catch ({ response }) {
        commit('notifications/addNotifyErrors', ['Ошибка авторизации'], { root: true });
        return Promise.reject(response);
      } finally {
        commit('setLoading', false);
      }
    },

    async loadMe({ state, commit }) {
      commit('getToken');
      if (state.accessToken) {
        commit('setLoading', true);
        try {
          const { data } = await accountApi.loadMe();
          commit('setUser', data);
        } catch (err) {
          commit('logoutUser');
          commit('notifications/addNotifyErrors', ['Ошибка загрузки данных пользователя'], { root: true });
          return Promise.reject(err);
        } finally {
          commit('setLoading', false);
        }
      }
    },

    async logout({ commit }) {
      commit('logoutUser');
      commit('setLoading', false);

      // try {
      //   await authApi.logout();
      //   return true;
      // } catch (err) {
      //   commit('notifications/addNotifyErrors', ['Ошибка при Logout'], { root: true });
      //   return Promise.reject(err);
      // } finally {
      //   commit('logoutUser');
      //   commit('setLoading', false);
      // }
    },
  },

  mutations: {
    setInitialized(state) {
      state.initialized = true;
    },
    setLoading(state, data) {
      state.loading = data;
    },
    setUser(state, user) {
      state.user = user;
    },
    getToken(state) {
      state.accessToken = getToken();
      state.refreshToken = getRefreshToken();
    },
    setToken(state, { accessToken, refreshToken }) {
      state.accessToken = accessToken;
      state.refreshToken = refreshToken;
      saveToken({ accessToken, refreshToken });
    },
    logoutUser(state) {
      state.user = { id: 123 }; // null;
      state.accessToken = '';
      state.refreshToken = '';
      destroyToken();
    },
  },

  getters: {
    initialized: (state) => state.initialized,
    loading: (state) => state.loading,
    token: (state) => state.accessToken,
    user: (state) => state.user,
    isAccessAllowed: (state) => (...roles) => roles.includes(state.user.userRole),
  },
};
